import {clsx} from 'clsx'
import type {PropsWithChildren} from 'react'

import {useIsMergeBoxSidePanel} from '../../../contexts/MergeBoxLayoutContext'
import {MergeControl, type MergeControlProps} from './MergeControl'
import {useMergeControlState} from './merge-control/merge-control-context'

export type MergeSectionProps = MergeControlProps

/**
 * Renders the merge actions section of the merge box, specifically the merge button
 * Depending on configurations, a viewer can select a merge method, merge directly, or add the pull request to the merge queue
 */
function MergeSectionFrame({children}: PropsWithChildren) {
  const {isConfirmingMergeInfo, mergeControlModel} = useMergeControlState()
  const isSidePanel = useIsMergeBoxSidePanel()

  return (
    <div
      hidden={mergeControlModel.visibility === 'hidden'}
      className={clsx(
        isSidePanel ? 'tmp-pt-3 tmp-px-3' : 'bgColor-muted borderColor-muted tmp-p-3',
        isConfirmingMergeInfo ? 'rounded-2' : 'rounded-bottom-2',
      )}
    >
      {children}
    </div>
  )
}

export function MergeSection(props: MergeSectionProps) {
  return (
    <MergeControl {...props}>
      <MergeSectionFrame>
        <MergeControl.BypassToggle className="tmp-mb-3" />
        <MergeControl.Control />
      </MergeSectionFrame>
    </MergeControl>
  )
}
